goog.provide("shadow.js.shim.module$ol$extent");
goog.provide("module$shadow_js_shim_module$ol$extent");
shadow.js.shim.module$ol$extent = shadow.js.nativeProvides["ol/extent"] = shadow$bridge("ol/extent");
module$shadow_js_shim_module$ol$extent.default = shadow.js.shim.module$ol$extent;
